import { injectTermIntoSimpleSearch } from '../injectTermIntoSimpleSearch';

export const buildHQLQueryFromString = (query: string | null): string => {
  if (typeof query !== 'string' || !query.length) {
    return '';
  }

  return injectTermIntoSimpleSearch(query.trim());
};
